export const colors = {
  primary: "#CDF0EA",
  secondary: "#F9F9F9",
  secondaryLight: "#fbf6f6",
  extra: "#F7DBF0",
  extraDark:"#fbbfeb",
  extra2: "#BEAEE2",
  darkGray: "#464646",
};

export const fonts = {
  openSans: "'Open Sans', sans-serif",
};

export const shadows = {
  common: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  common2: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
};
